import gql from "graphql-tag"

export const DELETE_CAMPAIGN = gql`
  mutation($storeId: String!, $campaignId: String!) {
    deleteCampaign(restaurantId: $storeId, id: $campaignId)
  }
`
